import {apolloClient} from '@/apollo'
import {
    ADD_DAY_ZONE_ASSIGNMENT,
    ADD_NEW_DELIVERY_ZONE,
    ADD_NEW_PUBLIC_HOLIDAY,
    ADD_NEW_TIMEZONE, DELETE_DAY_ZONE_ASSIGNMENT, DELETE_PUBLIC_HOLIDAY, UPDATE_DAY_ZONE_ASSIGNMENT,
    UPDATE_DELIVERY_ZONE, UPDATE_PUBLIC_HOLIDAY,
    UPDATE_TIMEZONE
} from "@/gql/system-settings";

export const state = {
    loading: false,
    errors: [],
}
export const getters = {
    settingsLoading: state => state.loading,
    settingsErrors: state => state.errors
}
export const actions = {

    async addNewDeliveryZones({commit}, zoneData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            await apolloClient.mutate({
                mutation: ADD_NEW_DELIVERY_ZONE,
                variables: zoneData
            })
            return true
        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },
    async updateDeliveryZone({commit}, zoneData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {zone}} = await apolloClient.mutate({
                mutation: UPDATE_DELIVERY_ZONE,
                variables: zoneData,
            })
            return zone.zone

        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },

    async addNewTimezone({commit}, zoneData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {timezone}} = await apolloClient.mutate({
                mutation: ADD_NEW_TIMEZONE,
                variables: zoneData
            })
            return timezone.timezone
        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },
    async updateTimezone({commit}, zoneData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {timezone}} = await apolloClient.mutate({
                mutation: UPDATE_TIMEZONE,
                variables: zoneData,
            })
            return timezone.timezone

        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },

    async addNewPublicHoliday({commit}, holidayData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {publicHoliday}} = await apolloClient.mutate({
                mutation: ADD_NEW_PUBLIC_HOLIDAY,
                variables: holidayData
            })
            return publicHoliday.publicHoliday
        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },
    async updatePublicHoliday({commit}, holidayData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {publicHoliday}} = await apolloClient.mutate({
                mutation: UPDATE_PUBLIC_HOLIDAY,
                variables: holidayData,
            })
            return publicHoliday.publicHoliday

        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },
    async deletePublicHoliday({commit}, holidayData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {deletePublicHoliday}} = await apolloClient.mutate({
                mutation: DELETE_PUBLIC_HOLIDAY,
                variables: holidayData,
            })
            console.log(deletePublicHoliday)
            return deletePublicHoliday

        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },

    async addNewDayZoneAssignment({commit}, zoneData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {assignedDay}} = await apolloClient.mutate({
                mutation: ADD_DAY_ZONE_ASSIGNMENT,
                variables: zoneData
            })
            return assignedDay
        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },
    async updateDayZoneAssignment({commit}, zoneData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {assignedDay}} = await apolloClient.mutate({
                mutation: UPDATE_DAY_ZONE_ASSIGNMENT,
                variables: zoneData,
            })
            return assignedDay

        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },
    async deleteDayZoneAssignment({commit}, zoneData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {deleteAssignedDay}} = await apolloClient.mutate({
                mutation: DELETE_DAY_ZONE_ASSIGNMENT,
                variables: zoneData,
            })
            return deleteAssignedDay

        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },
}
export const mutations = {
    LOADING_TRUE(state){
        state.loading = true
    },
    LOADING_FALSE(state){
        state.loading = false
    },
    SET_ERRORS(state, payload){
        state.errors = payload
    },
    REMOVE_ERRORS(state){
        state.errors = []
    }
}


